// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2hrOQ","infoBtn":"quickbooks_infoBtn__CSmlY","formBox":"quickbooks_formBox__2ug_9","formFooter":"quickbooks_formFooter__3y1OC"};